import { App } from 'vue'
import ZipInput from './LpZipInput.vue'

ZipInput.install = (Vue: App) => {
  Vue.component(ZipInput.name, ZipInput)
}

export default ZipInput
